function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ChooseDraftTemplate = require('./choose-draft.template');
var ChooseDraftOverlay = /*#__PURE__*/function () {
  function ChooseDraftOverlay(app, mod) {
    _classCallCheck(this, ChooseDraftOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    // Disable default backdrop close behavior so we can handle it custom
    this.overlay.clickBackdropToClose = false;
  }
  return _createClass(ChooseDraftOverlay, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var skipDiscovery,
          hasValidDrafts,
          drafts,
          draftCount,
          html,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              skipDiscovery = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              if (!(!skipDiscovery && this.mod.discoverDrafts)) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.mod.discoverDrafts();
            case 1:
              // ========================================================================
              // [DRAFT-CHECK] Log overlay render decision
              // ========================================================================
              console.log('[DRAFT-CHECK] ChooseDraftOverlay.render() called, skipDiscovery=' + skipDiscovery);

              // Double-check that valid drafts exist (defensive check)
              hasValidDrafts = this.mod.hasValidDrafts && this.mod.hasValidDrafts();
              if (hasValidDrafts) {
                _context.n = 2;
                break;
              }
              console.log('[DRAFT-CHECK] Overlay render blocked - no valid drafts exist (defensive check)');
              // Hide overlay if already shown
              this.overlay.hide();
              return _context.a(2);
            case 2:
              // ========================================================================
              // RENDER FROM IN-MEMORY DRAFT LIST (single source of truth)
              // ========================================================================
              // Always use this.mod.getDrafts() which returns this.mod.drafts
              // This ensures we're rendering from the same list that was mutated on delete
              drafts = this.mod.getDrafts();
              draftCount = drafts ? drafts.length : 0;
              console.log('[DRAFT-CHECK] Rendering overlay with draftCount=' + draftCount);
              html = ChooseDraftTemplate(this.app, this.mod, drafts, draftCount);
              this.overlay.show(html);
              setTimeout(function () {
                _this.attachEvents();
              }, 25);
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      // Close overlay (click outside or close button)
      var overlayCloseBtn = document.querySelector('.saito-overlay-close');
      if (overlayCloseBtn) {
        overlayCloseBtn.addEventListener('click', function () {
          _this2.handleDefaultDraft();
        });
      }

      // Click outside overlay (on backdrop) - handle custom behavior
      // Wait a bit for overlay to be fully rendered to get the correct backdrop element
      setTimeout(function () {
        var backdrop = document.querySelector("#saito-overlay-backdrop".concat(_this2.overlay.ordinal));
        if (backdrop) {
          backdrop.addEventListener('click', function (e) {
            // Only handle if clicking directly on backdrop, not children
            if (e.target === backdrop) {
              _this2.handleDefaultDraft();
            }
          });
        }
      }, 50);

      // Draft row click handlers (up to 3 drafts)
      var draftRows = document.querySelectorAll('.choose-draft .row[data-draft-id]');
      draftRows.forEach(function (row) {
        var draftId = row.getAttribute('data-draft-id');
        if (draftId) {
          row.addEventListener('click', /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
              var intent;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    if (!e.target.closest('.delete')) {
                      _context2.n = 1;
                      break;
                    }
                    return _context2.a(2);
                  case 1:
                    intent = {
                      mode: 'select',
                      draftId: draftId
                    };
                    _this2.overlay.hide();
                    if (!_this2.mod.create_post_ui) {
                      _context2.n = 2;
                      break;
                    }
                    _context2.n = 2;
                    return _this2.mod.create_post_ui.initializeDocument(intent);
                  case 2:
                    return _context2.a(2);
                }
              }, _callee2);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        }
      });

      // Delete icon click handlers (stop propagation to prevent row selection)
      var deleteIcons = document.querySelectorAll('.choose-draft .delete');
      deleteIcons.forEach(function (icon) {
        var draftId = icon.getAttribute('data-draft-id');
        if (draftId) {
          icon.addEventListener('click', function (e) {
            e.stopPropagation(); // Prevent row selection
            _this2.handleDraftDelete(draftId);
          });
        }
      });

      // Create New Post row click handler
      var createNewRow = document.querySelector('#stack-choose-draft-create-new');
      if (createNewRow) {
        createNewRow.addEventListener('click', function () {
          _this2.handleCreateNew();
        });
      }
    }

    /**
     * Handle selecting a draft to edit
     * Returns session intent object to initializeDocument()
     */
  }, {
    key: "handleDraftSelect",
    value: function () {
      var _handleDraftSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(draftId) {
        var intent;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              // Return intent and re-initialize editor with it
              intent = {
                mode: 'select',
                draftId: draftId
              };
              this.overlay.hide();
              if (!this.mod.create_post_ui) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return this.mod.create_post_ui.initializeDocument(intent);
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleDraftSelect(_x2) {
        return _handleDraftSelect.apply(this, arguments);
      }
      return handleDraftSelect;
    }()
    /**
     * Handle default action (resume most recent draft)
     */
  }, {
    key: "handleDefaultDraft",
    value: function () {
      var _handleDefaultDraft = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var drafts, mostRecent, intent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              drafts = this.mod.getDrafts();
              if (!(drafts && drafts.length > 0)) {
                _context4.n = 2;
                break;
              }
              mostRecent = drafts[0];
              intent = {
                mode: 'resume',
                draftId: mostRecent.id
              };
              this.overlay.hide();
              if (!this.mod.create_post_ui) {
                _context4.n = 1;
                break;
              }
              _context4.n = 1;
              return this.mod.create_post_ui.initializeDocument(intent);
            case 1:
              _context4.n = 3;
              break;
            case 2:
              // No drafts, create new
              this.handleCreateNew();
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleDefaultDraft() {
        return _handleDefaultDraft.apply(this, arguments);
      }
      return handleDefaultDraft;
    }()
    /**
     * Handle creating a new document
     * Returns session intent object to initializeDocument()
     */
  }, {
    key: "handleCreateNew",
    value: function handleCreateNew() {
      var intent = {
        mode: 'new'
      };
      this.overlay.hide();
      if (this.mod.create_post_ui) {
        this.mod.create_post_ui.initializeDocument(intent);
      }
    }

    /**
     * Handle deleting a draft
     * Calls stack.js to delete the draft (archive + in-memory list)
     * Shows confirmation alert before deletion
     * After deletion: rediscover drafts and re-render overlay
     */
  }, {
    key: "handleDraftDelete",
    value: function () {
      var _handleDraftDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(draftId) {
        var deleted, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (draftId) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              if (confirm('Are you sure you want to delete this draft?')) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              _context5.n = 3;
              return this.mod.deleteDraft;
            case 3:
              _t = _context5.v;
              if (!_t) {
                _context5.n = 4;
                break;
              }
              _t = this.mod.deleteDraft(draftId);
            case 4:
              deleted = _t;
              if (deleted) {
                _context5.n = 5;
                break;
              }
              console.error('Stack: Failed to delete draft');
              return _context5.a(2);
            case 5:
              _context5.n = 6;
              return this.render(true);
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function handleDraftDelete(_x3) {
        return _handleDraftDelete.apply(this, arguments);
      }
      return handleDraftDelete;
    }()
  }]);
}();
module.exports = ChooseDraftOverlay;